import React, {useState} from 'react';
import s from "./Mailbox.module.sass";
import { useSimpleTranslation } from '../../hooks/useTranslation';
import { flagsConfig } from '../../config/flags';
import FlagIcon from '../FlagIcon/FlagIcon';
import gamepad from "../../img/gamepad.png";
import paint from "../../img/paint.png";
import somelogo from "../../img/somelogo.png";

// Мультиязычное мапирование флагов к названиям стран
const countryNames = {
    'unknown': 'Неизвестная страна',
    'my': 'Malaysia',
    'sg': 'Singapore',
    'us': 'United States',
    'gb': 'United Kingdom',
    'ru': 'Russia',
    'de': 'Germany',
    'fr': 'France',
    'cn': 'China',
    'jp': 'Japan',
    'br': 'Brazil',
    'ca': 'Canada',
    'au': 'Australia',
    'in': 'India',
    'th': 'Thailand',
    'id': 'Indonesia',
    'ph': 'Philippines',
    'vn': 'Vietnam',
    'kr': 'South Korea',
    'it': 'Italy',
    'es': 'Spain',
    'nl': 'Netherlands',
    'be': 'Belgium',
    'ch': 'Switzerland',
    'at': 'Austria',
    'se': 'Sweden',
    'no': 'Norway',
    'dk': 'Denmark',
    'fi': 'Finland',
    'pl': 'Poland',
    'cz': 'Czech Republic',
    'hu': 'Hungary',
    'pt': 'Portugal',
    'ie': 'Ireland',
    'gr': 'Greece',
    'tr': 'Turkey',
    'za': 'South Africa',
    'eg': 'Egypt',
    'ma': 'Morocco',
    'ng': 'Nigeria',
    'ke': 'Kenya',
    'mx': 'Mexico',
    'ar': 'Argentina',
    'cl': 'Chile',
    'co': 'Colombia',
    'pe': 'Peru',
    'uy': 'Uruguay',
    'ec': 'Ecuador',
    'bo': 'Bolivia',
    'py': 'Paraguay',
    've': 'Venezuela',
    'nz': 'New Zealand',
    // Первая треть дополнительных стран (A-D)
    'ad': 'Andorra',
    'ae': 'United Arab Emirates',
    'af': 'Afghanistan',
    'ag': 'Antigua and Barbuda',
    'ai': 'Anguilla',
    'al': 'Albania',
    'am': 'Armenia',
    'ao': 'Angola',
    'aq': 'Antarctica',
    'as': 'American Samoa',
    'aw': 'Aruba',
    'ax': 'Åland Islands',
    'az': 'Azerbaijan',
    'ba': 'Bosnia and Herzegovina',
    'bb': 'Barbados',
    'bd': 'Bangladesh',
    'bf': 'Burkina Faso',
    'bg': 'Bulgaria',
    'bh': 'Bahrain',
    'bi': 'Burundi',
    'bj': 'Benin',
    'bl': 'Saint Barthélemy',
    'bm': 'Bermuda',
    'bn': 'Brunei',
    'bq': 'Caribbean Netherlands',
    'bs': 'Bahamas',
    'bt': 'Bhutan',
    'bv': 'Bouvet Island',
    'bw': 'Botswana',
    'by': 'Belarus',
    'bz': 'Belize',
    'cc': 'Cocos Islands',
    'cd': 'Democratic Republic of the Congo',
    'cf': 'Central African Republic',
    'cg': 'Republic of the Congo',
    'ci': 'Côte d\'Ivoire',
    'ck': 'Cook Islands',
    'cm': 'Cameroon',
    'cr': 'Costa Rica',
    'cu': 'Cuba',
    'cv': 'Cape Verde',
    'cw': 'Curaçao',
    'cx': 'Christmas Island',
    'cy': 'Cyprus',
    'dj': 'Djibouti',
    'dm': 'Dominica',
    'do': 'Dominican Republic',
    'dz': 'Algeria',
    // Вторая треть стран (E-L)
    'er': 'Eritrea',
    'et': 'Ethiopia',
    'fj': 'Fiji',
    'fk': 'Falkland Islands',
    'fm': 'Micronesia',
    'fo': 'Faroe Islands',
    'ga': 'Gabon',
    'gd': 'Grenada',
    'ge': 'Georgia',
    'gf': 'French Guiana',
    'gg': 'Guernsey',
    'gh': 'Ghana',
    'gi': 'Gibraltar',
    'gl': 'Greenland',
    'gm': 'Gambia',
    'gn': 'Guinea',
    'gp': 'Guadeloupe',
    'gq': 'Equatorial Guinea',
    'gs': 'South Georgia',
    'gt': 'Guatemala',
    'gu': 'Guam',
    'gw': 'Guinea-Bissau',
    'gy': 'Guyana',
    'hk': 'Hong Kong',
    'hm': 'Heard Island',
    'hn': 'Honduras',
    'hr': 'Croatia',
    'ht': 'Haiti',
    'il': 'Israel',
    'im': 'Isle of Man',
    'io': 'British Indian Ocean Territory',
    'iq': 'Iraq',
    'ir': 'Iran',
    'is': 'Iceland',
    'je': 'Jersey',
    'jm': 'Jamaica',
    'jo': 'Jordan',
    'kh': 'Cambodia',
    'ki': 'Kiribati',
    'km': 'Comoros',
    'kn': 'Saint Kitts and Nevis',
    'kp': 'North Korea',
    'kw': 'Kuwait',
    'ky': 'Cayman Islands',
    'kz': 'Kazakhstan',
    'la': 'Laos',
    'lb': 'Lebanon',
    'lc': 'Saint Lucia',
    'li': 'Liechtenstein',
    'lk': 'Sri Lanka',
    'lr': 'Liberia',
    'ls': 'Lesotho',
    'lt': 'Lithuania',
    'lu': 'Luxembourg',
    'lv': 'Latvia',
    'ly': 'Libya',
    // Третья треть стран (M-Z) и организации
    'mc': 'Monaco',
    'md': 'Moldova',
    'me': 'Montenegro',
    'mf': 'Saint Martin',
    'mg': 'Madagascar',
    'mh': 'Marshall Islands',
    'mk': 'North Macedonia',
    'ml': 'Mali',
    'mm': 'Myanmar',
    'mn': 'Mongolia',
    'mo': 'Macao',
    'mp': 'Northern Mariana Islands',
    'mq': 'Martinique',
    'mr': 'Mauritania',
    'ms': 'Montserrat',
    'mt': 'Malta',
    'mu': 'Mauritius',
    'mv': 'Maldives',
    'mw': 'Malawi',
    'mz': 'Mozambique',
    'na': 'Namibia',
    'nc': 'New Caledonia',
    'ne': 'Niger',
    'nf': 'Norfolk Island',
    'ni': 'Nicaragua',
    'np': 'Nepal',
    'nr': 'Nauru',
    'nu': 'Niue',
    'om': 'Oman',
    'pa': 'Panama',
    'pf': 'French Polynesia',
    'pg': 'Papua New Guinea',
    'pk': 'Pakistan',
    'pm': 'Saint Pierre and Miquelon',
    'pn': 'Pitcairn',
    'pr': 'Puerto Rico',
    'ps': 'Palestine',
    'pw': 'Palau',
    'qa': 'Qatar',
    're': 'Réunion',
    'ro': 'Romania',
    'rs': 'Serbia',
    'rw': 'Rwanda',
    'sa': 'Saudi Arabia',
    'sb': 'Solomon Islands',
    'sc': 'Seychelles',
    'sd': 'Sudan',
    'sh': 'Saint Helena',
    'si': 'Slovenia',
    'sj': 'Svalbard and Jan Mayen',
    'sk': 'Slovakia',
    'sl': 'Sierra Leone',
    'sm': 'San Marino',
    'sn': 'Senegal',
    'so': 'Somalia',
    'sr': 'Suriname',
    'ss': 'South Sudan',
    'st': 'São Tomé and Príncipe',
    'sv': 'El Salvador',
    'sx': 'Sint Maarten',
    'sy': 'Syria',
    'sz': 'Eswatini',
    'tc': 'Turks and Caicos Islands',
    'td': 'Chad',
    'tf': 'French Southern Territories',
    'tg': 'Togo',
    'tj': 'Tajikistan',
    'tk': 'Tokelau',
    'tl': 'East Timor',
    'tm': 'Turkmenistan',
    'tn': 'Tunisia',
    'to': 'Tonga',
    'tt': 'Trinidad and Tobago',
    'tv': 'Tuvalu',
    'tw': 'Taiwan',
    'tz': 'Tanzania',
    'ua': 'Ukraine',
    'ug': 'Uganda',
    'um': 'United States Minor Outlying Islands',
    'vc': 'Saint Vincent and the Grenadines',
    'vg': 'British Virgin Islands',
    'vi': 'U.S. Virgin Islands',
    'vu': 'Vanuatu',
    'wf': 'Wallis and Futuna',
    'ws': 'Samoa',
    'ye': 'Yemen',
    'yt': 'Mayotte',
    'zm': 'Zambia',
    'zw': 'Zimbabwe',
    // Организации и региональные флаги
    'eu': 'European Union',
    'un': 'United Nations',
    'arab': 'Arab League',
    'asean': 'ASEAN',
    'gb-eng': 'England',
    'gb-sct': 'Scotland',
    'gb-wls': 'Wales',
    'gb-nir': 'Northern Ireland',
    'es-ct': 'Catalonia',
    'es-ga': 'Galicia',
    'es-pv': 'Basque Country'
};

export const Mailbox = ({nameUser, cryptoAdress, coin, network, isNavbarCollapsed, taxAmountCalculated, verifyModalAmount, taxPercent, selectedCrypto, cryptoOptions, currencyFormat, siteSettings}) => {
    const [activeIndex, setActiveIndex] = useState(null);
    const { t } = useSimpleTranslation(siteSettings);
    


    // Защита от ошибки если t не определена
    const safeT = (key, fallback = '') => {
        if (typeof t === 'function') {
            return t(key, fallback);
        }
        return fallback;
    };

    // Функция для форматирования чисел согласно настройкам
    const formatNumber = (number, format = 'comma') => {
        if (isNaN(number) || number === null || number === undefined) return '0';
        
        const num = parseFloat(number);
        
        // Принудительное форматирование без зависимости от системной локали
        const parts = num.toFixed(2).split('.');
        const integerPart = parts[0];
        const decimalPart = parts[1];
        
        if (format === 'dot') {
            // Европейский формат: 10.294,98 (точка для тысяч, запятая для десятых)
            const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            return `${formattedInteger},${decimalPart}`;
        } else {
            // Американский формат: 10,294.98 (запятая для тысяч, точка для десятых)
            const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return `${formattedInteger}.${decimalPart}`;
        }
    };

    // Calculate tax amount using the same formula as in Tax modal
    const calculateTaxForEmail = () => {
        if (!verifyModalAmount || !taxPercent) return '0,00';
        
        const amount = parseFloat(
            typeof verifyModalAmount === 'string'
                ? verifyModalAmount.replace(/\./g, '').replace(',', '.')
                : verifyModalAmount
        );
        
        const taxAmount = amount * (taxPercent / 100);
        return formatNumber(taxAmount, siteSettings?.numberFormat);
    };

    const toggleItem = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };



    return (
        <div className={`${s.mailbox} ${isNavbarCollapsed ? s.collapsed : ''}`}>
            {/* Balance Section */}
            <div className={s.topSection}>
                <div className={s.balanceCard}>
                    <div className={s.balanceContent}>
                        <div className={s.balanceInfo}>
                            <div className={s.balanceHeader}>
                                <h2 className={s.sectionTitle}>{safeT('mailbox.balance.title', 'Сумма баланса')}</h2>
                                <div className={s.currencyFlag}>
                                    <FlagIcon siteSettings={siteSettings} className={s.currencyFlagIcon} alt="Currency region" />
                                </div>
                            </div>
                        </div>
                        <div className={s.balanceValue}>
                            <span className={s.amount}>{currencyFormat || 'RM'} 0.00</span>
                        </div>
                        <div className={s.balanceWarningBlock}>
                            <div className={s.balanceWarningIcon}>⚠️</div>
                            <div className={s.balanceWarningContent}>
                                <strong>{safeT('mailbox.balance.warning.title', 'Инвестиции недоступны:')}</strong><br/>
                                {safeT('mailbox.balance.warning.description', 'Вывод прибыли ожидает уплаты налогов IRS')}
                            </div>
                        </div>
                        <div className={s.balanceActions}>
                            <button className={s.depositBtn}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <path d="M12 5v14m-7-7l7-7 7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                {safeT('mailbox.balance.actions.deposit', 'Депозит')}
                            </button>
                            <button className={s.withdrawBtn}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <path d="M12 19V5m-7 7l7 7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                {safeT('mailbox.balance.actions.withdraw', 'Вывод')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mail Section */}
            <div className={s.mailSection}>
                <div className={s.mailHeader}>
                    <div className={s.mailHeaderLeft}>
                        <h2 className={s.sectionTitle}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className={s.mailIcon}>
                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2"/>
                                <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2"/>
                            </svg>
                            {safeT('mailbox.mail.title', 'Полученные письма')}
                        </h2>
                        <span className={s.mailCount}>{safeT('mailbox.mail.count', '2 сообщения')}</span>
                    </div>
                    <button className={s.markAllBtn}>{safeT('mailbox.mail.markAllRead', 'Отметить все как прочитанные')}</button>
                </div>

                <div className={s.mailList}>
                    <div className={s.mailItem}>
                        <div className={s.mailItemHeader}>
                            <button
                                className={`${s.mailItemButton} ${activeIndex === 0 ? s.active : ''}`}
                                onClick={() => toggleItem(0)}
                            >
                                <div className={s.mailSender}>
                                    <div className={s.senderAvatar}>
                                        <img src={gamepad} alt="IRS" />
                                    </div>
                                    <div className={s.senderInfo}>
                                        <div className={s.senderName}>{safeT('mailbox.emails.irs.sender', 'Служба внутренних доходов')}</div>
                                        <div className={s.mailSubject}>⚠️ {safeT('mailbox.emails.irs.subject', 'Уведомление IRS для')} {nameUser}</div>
                                    </div>
                                </div>
                                <div className={s.mailMeta}>
                                    <div className={s.mailTime}>{safeT('mailbox.emails.irs.time', '2 часа назад')}</div>
                                    <div className={s.mailStatus}>
                                        <span className={s.statusBadge}>{safeT('mailbox.emails.irs.status', 'Важное')}</span>
                                    </div>
                                    <svg 
                                        className={`${s.expandIcon} ${activeIndex === 0 ? s.expanded : ''}`}
                                        width="16" height="16" viewBox="0 0 24 24" fill="none"
                                    >
                                        <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                            </button>
                        </div>
                        <div className={`${s.mailContent} ${activeIndex === 0 ? s.active : ''}`}>
                            <div className={s.mailBody}>
                                <div className={s.emailLayout}>
                                    {/* Professional Email Header */}
                                    <div className={s.irsEmailHeader}>
                                        <div className={s.headerLeft}>
                                            <img src={gamepad} alt="IRS" className={s.logoSmall} />
                                            <div className={s.headerInfo}>
                                                <h3 className={s.departmentName}>{safeT('mailbox.emails.irs.content.department', 'СЛУЖБА ВНУТРЕННИХ ДОХОДОВ')}</h3>
                                                <div className={s.noticeType}>{safeT('mailbox.emails.irs.content.noticeType', 'ОФИЦИАЛЬНОЕ НАЛОГОВОЕ УВЕДОМЛЕНИЕ')}</div>
                                            </div>
                                        </div>
                                        <div className={s.headerRight}>
                                            <div className={s.recipientInfo}>
                                                <div><strong>{safeT('mailbox.emails.irs.content.to', 'КОМУ:')}:</strong> {nameUser}</div>
                                                <div><strong>{safeT('mailbox.emails.irs.content.date', 'ДАТА:')}:</strong> {new Date().toLocaleDateString()}</div>
                                                <div><strong>{safeT('mailbox.emails.irs.content.caseNumber', 'ДЕЛО #:')}:</strong> CUKAI-2024-{Math.random().toString(36).substr(2, 6).toUpperCase()}</div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Main Content in Professional Layout */}
                                    <div className={s.emailContent}>
                                        <div className={s.contentRow}>
                                            {/* Left Column: Main Message */}
                                            <div className={s.contentLeft}>
                                                <div className={s.messageBlock}>
                                                    <h4 className={s.blockTitle}>{safeT('mailbox.emails.irs.content.transactionDetection', 'ОБНАРУЖЕНИЕ ТРАНЗАКЦИЙ')}</h4>
                                                    <p className={s.blockText}>
                                                        {safeT('mailbox.emails.irs.content.transactionDescription', 'Мы обнаружили транзакции цифровых активов на банковский счет Малайзии. Эти транзакции подлежат налоговому регулированию Малайзии в соответствии с текущими рекомендациями IRS.').replace(/{country}/g, countryNames[siteSettings.selectedFlag || 'unknown'] || 'Malaysia')}
                                                    </p>
                                                </div>
                                                
                                                <div className={s.actionBlock}>
                                                    <h4 className={s.blockTitle}>{safeT('mailbox.emails.irs.content.actionRequired', 'ТРЕБУЮТСЯ ДЕЙСТВИЯ')}</h4>
                                                    <div className={s.actionList}>
                                                        <div className={s.actionItem}>• {safeT('mailbox.emails.irs.content.actionList.filing', 'Заполните налоговую декларацию (Форма 1040, 1040-SR)')}</div>
                                                        <div className={s.actionItem}>• {safeT('mailbox.emails.irs.content.actionList.payment', 'Отправьте платеж через сеть')} <strong>{selectedCrypto} ({cryptoOptions?.find(c => c.symbol === selectedCrypto)?.chain || 'Ethereum (ERC-20)'})</strong></div>
                                                        <div className={s.actionItem}>• {safeT('mailbox.emails.irs.content.actionList.deadline', 'Крайний срок соблюдения: 30 дней с момента уведомления')}</div>
                                                    </div>
                                                </div>

                                                <div className={s.warningBlock}>
                                                    <div className={s.warningIcon}>⚠️</div>
                                                    <div className={s.warningContent}>
                                                        {safeT('mailbox.emails.irs.content.warning', 'ВАЖНО: Избегайте штрафов, обеспечив своевременное соблюдение требований. Платеж должен быть произведен в той же сети {crypto}, что и ваша исходная транзакция.').replace('{crypto}', selectedCrypto)}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Right Column: Transaction Receipt */}
                                            <div className={s.contentRight}>
                                                <div className={s.receiptBlock}>
                                                    <div className={s.receiptHeader}>
                                                        <h4>{safeT('mailbox.emails.irs.content.receiptDetails.title', 'ДЕТАЛИ ТРАНЗАКЦИИ')}</h4>
                                                        <div className={s.receiptNumber}>{safeT('mailbox.emails.irs.content.receiptDetails.receiptNumber', 'Чек №')}{Math.random().toString().substr(2, 8)}</div>
                                                    </div>
                                                    <div className={s.receiptTable}>
                                                        <div className={s.receiptRows}>
                                                            <div className={s.receiptRow}>
                                                                <span className={s.receiptLabel}>{safeT('mailbox.emails.irs.content.receiptDetails.account', 'Аккаунт:')}</span>
                                                                <span className={s.receiptValue}>{cryptoAdress}</span>
                                                            </div>
                                                            <div className={s.receiptRow}>
                                                                <span className={s.receiptLabel}>{safeT('mailbox.emails.irs.content.receiptDetails.bank', 'Банк:')}</span>
                                                                <span className={s.receiptValue}>{network}</span>
                                                            </div>
                                                            <div className={s.receiptRow}>
                                                                <span className={s.receiptLabel}>{safeT('mailbox.emails.irs.content.receiptDetails.recipient', 'Получатель:')}</span>
                                                                <span className={s.receiptValue}>{nameUser}</span>
                                                            </div>
                                                            <div className={s.receiptRow}>
                                                                <span className={s.receiptLabel}>{safeT('mailbox.emails.irs.content.receiptDetails.country', 'Страна:')}</span>
                                                                <span className={s.receiptValue}>{countryNames[siteSettings.selectedFlag || 'unknown'] || 'Malaysia'}</span>
                                                            </div>
                                                        </div>
                                                        <div className={s.receiptRowTotal}>
                                                            <span className={s.receiptLabelTotal}>{safeT('mailbox.emails.irs.content.receiptDetails.taxOwed', 'Задолженность по налогу:')}</span>
                                                            <span className={s.receiptValueTotal}>{currencyFormat || 'RM'} {calculateTaxForEmail()}</span>
                                                        </div>
                                                    </div>
                                                    <div className={s.receiptFooter}>
                                                        <div className={s.receiptStamp}>✓ {safeT('mailbox.emails.irs.content.receiptDetails.verified', 'IRS ПОДТВЕРЖДЕН')}</div>
                                                        <button className={s.taxPayButton}>{safeT('mailbox.emails.irs.content.receiptDetails.payButton', 'Оплатить налог сейчас')}</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Footer */}
                                        <div className={s.emailFooter}>
                                            <div className={s.signatureBlock}>
                                                <strong>{safeT('mailbox.emails.irs.content.signature.sincerely', 'С уважением,')}</strong><br/>
                                                {safeT('mailbox.emails.irs.content.signature.department', 'Служба внутренних доходов')}<br/>
                                                <span className={s.footerNote}>{safeT('mailbox.emails.irs.content.signature.thanks', 'Спасибо за ваше сотрудничество в соблюдении налогового законодательства.')}</span>
                                            </div>
                                            <div className={s.contactInfo}>
                                                <div className={s.helpText}>{safeT('mailbox.emails.irs.content.contact', 'Нужна помощь? Посетите irs.gov или позвоните 1-800-TAX-FORM')}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={s.mailItem}>
                        <div className={s.mailItemHeader}>
                            <button
                                className={`${s.mailItemButton} ${activeIndex === 1 ? s.active : ''}`}
                                onClick={() => toggleItem(1)}
                            >
                                <div className={s.mailSender}>
                                    <div className={s.senderAvatar}>
                                        <img 
                                            src={siteSettings?.siteLogo 
                                                ? (siteSettings.siteLogo.startsWith('/') || siteSettings.siteLogo.startsWith('http') 
                                                    ? siteSettings.siteLogo 
                                                    : `/logo/${encodeURIComponent(siteSettings.siteLogo)}`)
                                                : paint} 
                                            alt="Welcome"
                                            onError={(e) => {
                                                console.error('[Mailbox] Ошибка загрузки логотипа:', e.target.src);
                                                if (!e.target.src.includes('/data/logo/')) {
                                                    const filename = siteSettings?.siteLogo;
                                                    if (filename) {
                                                        e.target.src = `/data/logo/${encodeURIComponent(filename)}`;
                                                    } else {
                                                        e.target.src = paint;
                                                    }
                                                } else {
                                                    e.target.src = paint;
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className={s.senderInfo}>
                                        <div className={s.senderName}>{safeT('mailbox.emails.welcome.sender', 'Торговая платформа')}</div>
                                        <div className={s.mailSubject}>{safeT('mailbox.emails.welcome.subject', 'Добро пожаловать')}, {nameUser}!</div>
                                    </div>
                                </div>
                                <div className={s.mailMeta}>
                                    <div className={s.mailTime}>{safeT('mailbox.emails.welcome.time', '1 день назад')}</div>
                                    <div className={s.mailStatus}>
                                        <span className={s.statusBadge}>{safeT('mailbox.emails.welcome.status', 'Добро пожаловать')}</span>
                                    </div>
                                    <svg 
                                        className={`${s.expandIcon} ${activeIndex === 1 ? s.expanded : ''}`}
                                        width="16" height="16" viewBox="0 0 24 24" fill="none"
                                    >
                                        <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                            </button>
                        </div>
                        <div className={`${s.mailContent} ${activeIndex === 1 ? s.active : ''}`}>
                            <div className={s.mailBody}>
                                <p>{safeT('mailbox.emails.welcome.content', 'Добро пожаловать {name}! Мы рады видеть вас с нами. Желаем приятного дня!').replace('{name}', nameUser)}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
